
<template>
  <div>
    <v-row class="mx-3 mb-2" align="center">
      <div v-if="val.income_confirmation">
        <span class="mr-2">
          <b>Confirmado em:</b>
          {{$moment(val.income_confirmation.confirmed_at).format('lll')}}
        </span>
        <span>
          <b>Confirmado por:</b>
          {{val.income_confirmation.confirmed_by_name}}
        </span>
      </div>
      <v-btn small outlined v-if="!val.income_confirmation" color="primary" @click="genConfirmation()" rounded><v-icon left>mdi-check</v-icon>confirmar dia</v-btn>
    </v-row>

    <v-dialog v-if="saving" v-model="saving" class="my-0" persistent max-width="500px">
      <v-alert type="info" :value="true">
        Salvando...
        <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import data_extract_mixin from '../data_extract_mixin'
import Api from '@/api/index'
export default {
  name: 'ConfirmationExtract',
  props: {
    val: {
      type: Object,
    },
    kind: {
      type: String
    },
    ref_date: {
      type: String
    }
  },
  mixins: [data_extract_mixin],
  data() {
    return {
      saving: false,
    }
  },
  methods: {
    genConfirmation() {
      let items = []
      if (this.val.companies) {
        items = Object.values(this.val.companies).map(c=> c.items).flat()
      } else {
        items = this.val.items.flat()
      }
      let new_extract_confirmation = {
        confirmed_ids: items.map(i=> i.id),
        kind: this.kind,
        reference_date: this.ref_date
      }
      
      this.saveExtract(new_extract_confirmation)

    },
    saveExtract(new_extract_confirmation){
      this.saving = true
      Api.IncomeExtract.create_confirmation(new_extract_confirmation).then(r=>r.data).then(d=> {
        this.successSaved()
        this.$router.go()
      }).catch((err) => {
        console.log({err});
      }).finally(()=> {
        this.saving = false
      })
    },
  },
}
</script>